import React from "react";

import { View, StyleSheet, Text, Platform } from "react-native";

import AppTheme from "../../AppTheme";
import ImageComponent from "../../common/ImageComponent";
import ChecklistItems from "./ChecklistItems";

export default function GetStartedChecklist({ title, currentStep, image }) {
  return (
    <View style={styles.container}>
      {title ? <Text style={styles.title}>{title}</Text> : null}

      <Text style={styles.subTitle}>
        In under 15 minutes, you’ll have the foundation needed to start setting
        goals & spending time better.
      </Text>

      <View style={{ width: "100%" }}>
        <ChecklistItems currentStep={currentStep} />

        <View
          style={{
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
          }}
        >
          <ImageComponent
            image={
              image || require("../../../../assets/onboarding-info/tasks.png")
            }
            style={styles.imageBg}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: "100%",
    //flex: 1,
    width: "100%",
    alignItems: "center",
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  subTitle: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontStyle: "italic",
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginTop: 16,
    paddingHorizontal: 8,
  },
  imageBg: {
    width: 274,
    height: 247,
    marginTop: 27,
    marginBottom: 40,
  },
});
